import React, {Component, Fragment} from 'react';
import {Card, CardBody, Row} from 'reactstrap';
import {withTranslation} from 'react-i18next';
import {Colxx, Separator} from '../../../../components/common/CustomBootstrap';
import moment from 'moment';
import {i18nizeDate, numberWithCommas} from '../../../../helpers/Utils';
import {baseTokenSymbol, reactTableText} from '../../../../constants/configs';
import ReactTableDateFilter from '../../../../components/ReactTableDateFilter';
import Breadcrumb from '../../../../containers/navs/Breadcrumb';
import ReactTable from 'react-table';
import Api from '../../../../services/Api';
import {keyBy, mapValues, omit} from 'lodash';
import ToolTip from '../../../../components/ToolTip';
import ReactTableTextFilter from '../../../../components/ReactTableTextFilter';
import TransactionDetails from '../../../../containers/TransactionDetails';
import {Link} from 'react-router-dom';

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deposits: [],
      pages: -1,
      loading: false,
      selectedStartDate: null,
      selectedEndDate: null,
      expanded: {},
    };
    this.renderDateFilter = this.renderDateFilter.bind(this);
  }

  fetchData = async state => {
    try {
      this.setState({loading: true});
      const offset = state.page * state.pageSize;
      const {data} = await Api.invoke(
        'GET',
        '/admin-ui/users-bank-deposits',
        null,
        {
          params: {
            offset,
            limit: state.pageSize,
            status: 'FAILED',
            ...(state.filtered.length ? omit(mapValues(keyBy(state.filtered, 'id'), 'value'), 'createdAt') : null),
            ...(this.state.selectedStartDate ? {createdFrom: moment(this.state.selectedStartDate).toISOString()} : null),
            ...(this.state.selectedEndDate ? {createdTo: moment(this.state.selectedEndDate).toISOString()} : null),
          },
        },
      );
      this.setState({
        deposits: data.deposits,
        pages: data.totalPage,
      });
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  getColumns = t => [
    {
      Header: t('First Name'),
      accessor: 'firstName',
      filterable: true,
      Filter: ReactTableTextFilter,
      Cell: props => <span>{props.original.legalFirstName ? props.original.legalFirstName : props.value}</span>
    },
    {
      Header: t('Last Name'),
      accessor: 'lastName',
      Filter: ReactTableTextFilter,
      Cell: props => <span>{props.original.legalLastName ? props.original.legalLastName : props.value}</span>,
      filterable: true,
    },
    {
      Header: t('Email'),
      accessor: 'email',
      minWidth: 140,
      filterable: true,
      Filter: ReactTableTextFilter,
    },
    {
      Header: `${t('Amount')} (${t(baseTokenSymbol)})`,
      accessor: 'amount',
      Cell: props => <span>{numberWithCommas(Number(props.value))}</span>,
    },
    {
      Header: t('Date'),
      accessor: 'createdAt',
      width: 140,
      Cell: props => <span>{i18nizeDate(props.value)}</span>,
      filterable: true,
      Filter: this.renderDateFilter,
    },
    {
      Header: t('Actions'),
      width: 60,
      Cell: props => <div>
        <ToolTip id={`view_${props.original.userId}`} text={t('View Stats')}>
          <Link to={{
            pathname: '/dashboard/users/' + props.original.userId,
          }}>
            <i className="simple-icon-eye view-icon text-large"/>
          </Link>
        </ToolTip>
      </div>,
    },
  ];

  renderDateFilter({onChange}) {
    const {selectedStartDate, selectedEndDate} = this.state;
    return <ReactTableDateFilter
      onChange={onChange}
      handleDateChange={this.handleDateChange}
      selectedStartDate={selectedStartDate}
      selectedEndDate={selectedEndDate}
    />;
  }

  handleDateChange = (type, date) => {
    this.setState({
      [type]: date,
    });
  };

  onExpanded = (newExpanded, index) => {
    this.setState({
      expanded: {
        ...this.state.expanded,
        [index[0]]: !!newExpanded[index[0]],
      },
    });
  };

  render() {
    const {t} = this.props;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={this.props.match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <ReactTable
                  manual
                  ref={el => {this.table = el;}}
                  className="-highlight"
                  data={this.state.deposits}
                  pages={this.state.pages}
                  loading={this.state.loading}
                  sortable={false}
                  resizable={true}
                  onFetchData={this.fetchData}
                  columns={this.getColumns(t)}
                  expanded={this.state.expanded}
                  onPageChange={() => {this.setState({expanded: {}});}}
                  onExpandedChange={this.onExpanded}
                  defaultPageSize={25}
                  style={{
                    width: '100%'
                  }}
                  {...reactTableText}
                  SubComponent={row => {
                    const {original} = row;
                    return (
                      <TransactionDetails
                        showForm={false}
                        transaction={{...original, type: 'deposit'}}
                      />
                    );
                  }}
                />
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}

export default withTranslation()(List);
